import { useCallback, useEffect, useState } from "react"
import classNames from "classnames"

import { useAppDispatch, useAppSelector } from "store/hooks"
import {
  mobileMenuOpenSelector,
  setVerticalMenuOpen,
  setVerticalMenuOpenMobile,
  verticalMenuOpenSelector,
} from "store/tempDataSlise"
import styles from "assets/scss/index.module.scss"
import logo from "assets/svg/logo-white.svg"
import { ReactComponent as MenuArrowRight } from "assets/svg/menu-arrow-right.svg"

import { useWindowResize } from "hooks/useWindowResize"
import { AccountSwitcher } from "components/common/AccountSwitcher"
import { Hamburger } from "components/common/Hamburger"
import { UserMenu } from "components/common/UserMenu"
import { VerticalMenu } from "components/common/VerticalMenu"
import { WarehouseMenu } from "components/common/VerticalMenu/menus"

import {
  HamburgerWrapper,
  LeftSideWrapper,
  LogoWrapper,
  MenuToggleButton,
  RightSideIconsWrapper,
  StyledLogo,
} from "../styled"

export const WerehouseTopbar = () => {
  const dispatch = useAppDispatch()
  const [isSticky, setSticky] = useState(false)
  const desktopMenuOpen = useAppSelector(verticalMenuOpenSelector)
  const mobileMenuOpen = useAppSelector(mobileMenuOpenSelector)
  const isLargeScreen = useWindowResize()
  const menuOpen = isLargeScreen ? desktopMenuOpen : mobileMenuOpen

  const handleScroll = () => {
    const distance = window.scrollY

    if (distance > 0 && !isSticky) {
      setSticky(true)
    } else if (distance === 0 && isSticky) {
      setSticky(false)
    }
  }

  useEffect(() => {
    const setStickyOnScroll = () => handleScroll()

    window.addEventListener("scroll", setStickyOnScroll)

    return () => {
      window.removeEventListener("scroll", setStickyOnScroll)
    }
  }, [isSticky])

  const handleMenuToggle = useCallback(() => {
    if (isLargeScreen) {
      dispatch(setVerticalMenuOpen(!menuOpen))
    } else {
      dispatch(setVerticalMenuOpenMobile(!menuOpen))
    }
  }, [dispatch, menuOpen, isLargeScreen])

  return (
    <header className={classNames(styles.topbar, { [styles.sticky]: isSticky })}>
      <VerticalMenu>
        <WarehouseMenu />
      </VerticalMenu>
      <LeftSideWrapper>
        <MenuToggleButton
          type="button"
          $isOpen={menuOpen}
          onClick={handleMenuToggle}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          <MenuArrowRight />
        </MenuToggleButton>
        <HamburgerWrapper>
          <Hamburger isOpen={menuOpen} onClick={handleMenuToggle} />
        </HamburgerWrapper>
        <LogoWrapper className={styles.logoWrapper} to="/">
          <StyledLogo className={styles.logo} src={logo} alt="logo" />
        </LogoWrapper>
      </LeftSideWrapper>
      <RightSideIconsWrapper>
        <AccountSwitcher />
        <UserMenu />
      </RightSideIconsWrapper>
    </header>
  )
}
